import React, { useState } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  Icon,
  VStack,
} from '@chakra-ui/react'
import { FiAlertTriangle } from 'react-icons/fi'
import { useAppTranslation } from '@/contexts/LanguageContext'
import { Group } from '@/types'

interface Props {
  isOpen: boolean
  onClose: () => void
  group: Group
  onConfirm: () => Promise<void>
}

export default function DeleteGroupModal({ isOpen, onClose, group, onConfirm }: Props) {
  const { t } = useAppTranslation(['admin', 'common'])
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDelete = async () => {
    setIsDeleting(true)
    try {
      await onConfirm()
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('groups.deleteGroupConfirmTitle', { ns: 'admin' })}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="center" py={2}>
            <Icon as={FiAlertTriangle} boxSize={10} color="red.500" />
            <Text textAlign="center" fontWeight="medium">
              {group.name}
            </Text>
            <Text textAlign="center" fontSize="sm" color="gray.500">
              {t('groups.deleteConfirm', { ns: 'admin' })}
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose} isDisabled={isDeleting}>
            {t('buttons.cancel', { ns: 'common' })}
          </Button>
          <Button colorScheme="red" onClick={handleDelete} isLoading={isDeleting}>
            {t('groups.deleteGroup', { ns: 'admin' })}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
